export const integrationRequestsTags = ['IntegrationRequests'] as const;
